import { StyleSheet, Image } from "react-native";
import { View } from "../shared/Themed";

export default function CompanyLogo() {
  return (
    <View style={[styles.box]}>
      <Image
        style={styles.tinyLogo}
        resizeMode="contain"
        source={require("../../assets/logo2.png")}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  box: {
    height: 45,
    marginTop: 15,
    position: "absolute",
  },
  tinyLogo: {
    width: 50,
    height: 30,
  },
});
